import { Outlet } from "react-router";

export default function Klientkontoerklaering() {
  return (
    <div className="container-xxl mt-4 mb-7">
      <Outlet />
    </div>
  );
}
